import * as yup from 'yup';

yup.addMethod(yup.string, 'descontoIgualValorBase', function (errorMessage) {
    return this.test('test-desconto-igual-valor-base', errorMessage, function (_value) {
        try {
            const { path, createError, parent } = this;
            let temErro = false;
            const { valorBase, valorDesconto, atualizarSomenteValorDesconto } = parent;

            const parseValorBase = Number.parseFloat(valorBase);
            const parseValorDesconto = Number.parseFloat(valorDesconto);

            if (parseValorBase === parseValorDesconto) {
                temErro = true;
            }

            if (atualizarSomenteValorDesconto) {
                temErro = false;
            }

            return (
                !temErro ||
                createError({
                    path,
                    message: errorMessage
                })
            );
        } catch (error) {
            console.log(error);
        }
    });
});
yup.addMethod(yup.string, 'descontoMaiorValorBase', function (errorMessage) {
    return this.test('test-desconto-maior-valor-base', errorMessage, function (_value) {
        try {
            const { path, createError, parent } = this;
            let temErro = false;
            const { valorBase, valorDesconto, atualizarSomenteValorDesconto } = parent;

            const parseValorBase = Number.parseFloat(valorBase?.replace(',', '.'));
            const parseValorDesconto = Number.parseFloat(valorDesconto?.replace(',', '.'));

            if (parseValorDesconto > parseValorBase) {
                temErro = true;
            }

            if (atualizarSomenteValorDesconto) {
                temErro = false;
            }

            return (
                !temErro ||
                createError({
                    path,
                    message: errorMessage
                })
            );
        } catch (error) {
            console.log(error);
        }
    });
});

yup.addMethod(yup.string, 'valorBaseNaoPodeSerZero', function (errorMessage) {
    return this.test('test-valorBase-nao-pode-ser-zero', errorMessage, function (_value) {
        const { path, createError, parent } = this;
        let temErro = false;
        const { valorBase, planoZTA } = parent;
        const parseValorBase = Number.parseFloat(valorBase);

        if (planoZTA) {
            return true;
        }

        if (parseValorBase === 0) {
            temErro = true;
        }

        return (
            !temErro ||
            createError({
                path,
                message: errorMessage
            })
        );
    });
});

export const mensalidadesSchema = yup.object().shape({
    planoZTA: yup.boolean(),
    valorBase: yup.string().transform(value => value.replace(/_|,|R\$/g, ''))
        .valorBaseNaoPodeSerZero('Valor Base nao pode ser igual a zero')
        .when(['atualizarSomenteValorDesconto', 'planoZTA'], {
            is: (atualizarSomenteValorDesconto, planoZTA) => !atualizarSomenteValorDesconto && !planoZTA,
            then: yup.string().required('Preencha valor base para proseguir.'),
            otherwise: yup.string()
        }),
    valorDesconto: yup
        .string()
        .transform(value => value.replace(/_|,|R\$/g, ''))
        .descontoIgualValorBase('O valor do desconto não pode ser igual ao valor base')
        .nullable()
        .descontoMaiorValorBase('O valor do desconto não pode ser maior que o valor base'),
    dataInicioDesconto: yup.date().nullable()
        .when(
            'valorDesconto', {
                is: valorDesconto => valorDesconto,
                then: yup.date().required('Preencha uma data para início do desconto.'),
                otherwise: yup.date()
            }
        ),
    dataFinalDesconto: yup.date('insira uma data valida').nullable()
        .min(
            yup.ref('dataInicioDesconto'), 'A data final de desconto deve ser maior que a data inicial do desconto!'

        )
        .when('dataInicioDesconto', {
            is: true,
            then: yup.date().required('Caso a data de início esteja informada, data final deve ser preenchida!'),
            otherwise: yup.date()
        }),
    pagamentoCartao: yup.boolean(),
    pagamentoBoleto: yup.boolean(),
    pagamentoEscelsa: yup.boolean(),
    atualizarSomenteValorDesconto: yup.boolean(),
    formasPagamento: yup.lazy(value =>
        yup.boolean().test(
            'pelo-menos-uma-forma-pagamento',
            'Selecione pelo menos uma forma de pagamento',
            function (value) {
                try {
                    const { valorDesconto, pagamentoCartao, pagamentoBoleto, pagamentoEscelsa } = this.parent;

                    if (valorDesconto) {
                        return pagamentoCartao || pagamentoBoleto || pagamentoEscelsa;
                    }

                    return true;
                } catch (error) {
                    console.log(error);
                }
            }
        )
    )
});
